import { monthToString } from 'common/helpers';
import { Flex } from 'components';
import { getCalendarDays } from './helpers';
import { ICalendarDay } from './types';
import './style.scss';

interface IProps {
  year: number;
  month: number;
  day: number;

  onYearClick?: () => void;
  onMonthClick?: () => void;
  onDayClick?: (day: number) => void;
}

function StageDefault(props: IProps) {
  const weeks = getCalendarDays(props.year, props.month);

  return (
    <Flex
      direction='column'
      className='calendar-default-QLUY'
    >
      <Flex
        className='header-wpJx'
        alignItems='center'
        gap={10}
      >
        <div
          className='h-btn-q6jC year-jUal'
          tabIndex={0}
          role='button'
          onClick={props.onYearClick}
        >
          {props.year} год
        </div>
        <div
          className='h-btn-q6jC month-u8sX'
          tabIndex={0}
          role='button'
          onClick={props.onMonthClick}
        >
          {monthToString(props.month)}
        </div>
      </Flex>
      <Flex
        direction='column'
        gap={5}
      >
        <Flex>
          <Flex
            alignItems='flex-end'
            justifyContent='center'
            className='calendar-cell-ATwJ cell-h-zn4F'
            aria-disabled
          >
            Пн.
          </Flex>
          <Flex
            alignItems='flex-end'
            justifyContent='center'
            className='calendar-cell-ATwJ cell-h-zn4F'
            aria-disabled
          >
            Вт.
          </Flex>
          <Flex
            alignItems='flex-end'
            justifyContent='center'
            className='calendar-cell-ATwJ cell-h-zn4F'
            aria-disabled
          >
            Ср.
          </Flex>
          <Flex
            alignItems='flex-end'
            justifyContent='center'
            className='calendar-cell-ATwJ cell-h-zn4F'
            aria-disabled
          >
            Чт.
          </Flex>
          <Flex
            alignItems='flex-end'
            justifyContent='center'
            className='calendar-cell-ATwJ cell-h-zn4F'
            aria-disabled
          >
            Пт.
          </Flex>
          <Flex
            alignItems='flex-end'
            justifyContent='center'
            className='calendar-cell-ATwJ cell-h-zn4F weekend-SzD9'
            aria-disabled
          >
            Сб.
          </Flex>
          <Flex
            alignItems='flex-end'
            justifyContent='center'
            className='calendar-cell-ATwJ cell-h-zn4F weekend-SzD9'
            aria-disabled
          >
            Вс.
          </Flex>
        </Flex>
        {weeks.map((week, weekIndex) => (
          <Week
            key={weekIndex}
            week={week}
            onDayClick={props.onDayClick}
          />
        ))}
      </Flex>
    </Flex>
  );
}

interface IWeekProps {
  week: (ICalendarDay | null)[];
  onDayClick?: (day: number) => void;
}

function Week(props: IWeekProps) {
  const handleDayClick = (dayData: ICalendarDay | null) => {
    if (dayData == null) {
      return;
    }

    props.onDayClick?.(dayData.day);
  };

  return (
    <Flex>
      {props.week.map((day, dayIndex) => (
        <Day
          day={day}
          key={dayIndex}
          onDayClick={() => handleDayClick(day)}
        />
      ))}
    </Flex>
  );
}

interface IDayProps {
  day: ICalendarDay | null;
  onDayClick?: () => void;
}

function Day(props: IDayProps) {
  if (props.day == null) {
    return (
      <div
        aria-disabled
        className='calendar-cell-ATwJ'
      />
    );
  }

  const className = props.day.dayOfWeek > 4 ? 'calendar-cell-ATwJ weekend-SzD9' : 'calendar-cell-ATwJ';

  return (
    <Flex
      className={className}
      alignItems='center'
      justifyContent='center'
      tabIndex={0}
      role='button'
      onClick={props.onDayClick}
    >
      <span>{props.day.day}</span>
    </Flex>
  );
}

export default StageDefault;
